import { _js } from '@ifixit/utils/localize';
import { Fragment } from 'react';
import styled from 'styled-components';
import { color, shadow, fontSize, fontWeight, space, breakpoint } from '@ifixit/primitives';

const ActivityTitle = styled.h3`
   font-size: ${fontSize['3xl']};
   font-weight: 700;
   color: ${color.gray[900]};
   align-self: flex-start;
   margin-top: ${space[10]};
   margin-bottom: ${space[7]};

   @media only screen and (max-width: ${breakpoint.md}) {
      margin-top: ${space[7]};
      margin-bottom: ${space[5]};
   }
`;

const ActivityContainer = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   margin: -${space[3]} -${space[0]} ${space[5]};
   max-width: 100%;
`;

const ActivityCard = styled.div`
   display: flex;
   flex-direction: column;
   width: 32%;
   height: 264px;
   border-radius: ${space[2]};
   border: 1px solid ${color.gray[300]};
   overflow: hidden;
   margin: ${space[3]} ${space[0]};

   @media only screen and (max-width: ${breakpoint.md}) {
      width: 49%;
   }

   @media only screen and (max-width: ${breakpoint.sm}) {
      width: 100%;
   }
`;

const ActivityImage = styled.div`
   height: 200px;
   background-image: url(${props => props.$img});
   background-position: center;
   background-size: cover;
   transition-duration: 0.5s;

   &:hover {
      opacity: 50%;
   }
`;

const UserInfo = styled.div`
   display: flex;
   bottom: ${space[0]};
   height: 64px;
   width: 100%;
   padding: ${space[3]};
   background-color: ${color.white};
   color: ${color.gray[500]};
   border-bottom-left-radius: ${space[2]};
   border-bottom-right-radius: ${space[2]};
`;

const Avatar = styled.img`
   border-radius: 50%;
   height: 40px;
   width: 40px;
   margin-right: ${space[4]};
   transition-duration: 0.5s;

   &:hover {
      opacity: 50%;
   }
`;

const ActivityText = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
`;

const Author = styled.span`
   color: ${color.gray[900]};
   font-weight: ${fontWeight.bold};
   font-size: ${fontSize.md};
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
   word-break: break-all;

   ${UserInfo}:hover & {
      text-decoration: underline;
   }
`;

const AuthorActivity = styled.span`
   color: ${color.gray[500]};
   font-size: ${fontSize.md};
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
   word-break: break-all;
`;

const Link = styled.a`
   display: block;

   &:hover {
      text-decoration: none;
   }
`;

const Activity = ({ url, image_url, user_url, user_image, author, text }) => (
   <ActivityCard>
      <Link href={url} aria-label={_js('Check out the activity')}>
         <ActivityImage $img={image_url} />
      </Link>
      <Link href={user_url} aria-label={_js("Go to %1's profile", author)}>
         <UserInfo>
            <Avatar src={user_image} alt={author} />
            <ActivityText>
               <Author>{author}</Author>
               <AuthorActivity>{text}</AuthorActivity>
            </ActivityText>
         </UserInfo>
      </Link>
   </ActivityCard>
);

const ActivityDisplay = ({ data }) => {
   const title = _js('Latest Community Activity');

   return (
      <Fragment>
         <ActivityTitle>{title}</ActivityTitle>
         <ActivityContainer>
            {data.map((activity, i) => (
               <Activity
                  key={i}
                  url={activity.url}
                  image_url={activity.image_url}
                  user_url={activity.user_url}
                  user_image={activity.user_image}
                  author={activity.author}
                  text={activity.text}
               />
            ))}
         </ActivityContainer>
      </Fragment>
   );
};

export default ActivityDisplay;
